// Abrir una dirección de la propia web desde donde no hay router a mano (el aviso de la campana, el toast de un aviso:
// useSocket, Sidebar) con la MISMA navegación que tocar la notificación del sistema: la escucha
// features/oficina/abrirDesdeAviso.ts (montada en toda la app autenticada), que la pasa por `rutaDelUrl` y navega sin
// recargar. 04-11: los avisos de Santi llevan `url` (`oficina?santi=12`) y ningún agente.
// Sin nadie escuchando (no debería pasar), se carga la dirección; nunca la de otra web.

/** Devuelve true si se encargó de la dirección. */
type Oyente = (url: string) => boolean;

const oyentes = new Set<Oyente>();

export function escucharAbrirUrl(oyente: Oyente): () => void {
  oyentes.add(oyente);
  return () => {
    oyentes.delete(oyente);
  };
}

export function abrirUrlEnLaApp(url: string): void {
  for (const oyente of oyentes) if (oyente(url)) return;
  try {
    const raiz = new URL(import.meta.env.BASE_URL ?? '/', window.location.origin);
    const u = new URL(url.replace(/^\/+/, ''), raiz);
    if (u.origin === window.location.origin) window.location.assign(u.href);
  } catch {
    // Dirección rota: no se abre nada.
  }
}
